export const newNotificationCloseTimeout = 6000;
